module.exports = __webpack_public_path__ + "img/DeliveryLimited.5f3d08dd.png";